<div
  [ngClass]="{
    'fit-content': panelHeight === 'fit',
    'fill-content': panelHeight === 'fill',
    'selection-border': isSelected
  }"
  [ngStyle]="panelStyle"
  class="card-panel"
>
  @if (header) {
    <h3 class="{{ 'text-' + headerPosition }}">{{ header }}</h3>
  }
  <div
    [ngClass]="{ 'inner-panel rounded': innerPanel }"
    class="content-panel justify-content-{{ justifyContent }}"
  >
    <ng-content></ng-content>
  </div>
</div>
